import { ClipboardCheck, BarChart3, Users2, Headset, ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const STEPS = [
  {
    num: "01",
    title: "CONSULT",
    icon: ClipboardCheck,
    desc: "Share Your Requirements",
  },
  {
    num: "02",
    title: "ANALYZE",
    icon: BarChart3,
    desc: "We Understand & Plan",
  },
  {
    num: "03",
    title: "ASSIST",
    icon: Users2,
    desc: "Get the Best Solution",
  },
  {
    num: "04",
    title: "SUPPORT",
    icon: Headset,
    desc: "End-to-End Assistance",
  },
];

export default function OurProcess() {
  return (
    <section
      id="our-process"
      data-testid="our-process"
      className="relative bg-[#04102B] text-white py-24 md:py-32 overflow-hidden noise-overlay"
    >
      {/* Brand accent ribbon */}
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <div className="inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[10px] md:text-[11px] tracking-[0.35em] uppercase text-[#F0D788] font-display">
            <span>Simple Process</span>
            <span className="text-[#0F6B3D]">●</span>
            <span>Quick Solutions</span>
            <span className="text-[#0F6B3D]">●</span>
            <span>Complete Support</span>
          </div>

          <h2
            data-testid="process-heading"
            className="font-display text-[40px] md:text-[60px] mt-5 leading-[1.05] tracking-tight"
          >
            Our process, <em className="not-italic text-[#D4AF37]">made easy</em> for you
          </h2>
        </Reveal>

        <div className="mt-16 relative">
          {/* Connector arrows on lg+ */}
          <div className="hidden lg:flex absolute top-12 left-0 right-0 justify-between px-32 pointer-events-none">
            {[0, 1, 2].map((i) => (
              <ArrowRight key={i} size={22} className="text-[#D4AF37]/40" />
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {STEPS.map(({ num, title, icon: Icon, desc }, i) => (
              <Reveal key={num} delay={i * 100}>
                <div
                  data-testid={`process-step-${num}`}
                  className="group relative flex flex-col items-center text-center"
                >
                  <div
                    className="w-24 h-24 rounded-full grid place-items-center border-2 border-[#D4AF37]/55 group-hover:border-[#D4AF37] group-hover:scale-105 transition-all"
                    style={{
                      background:
                        "radial-gradient(circle at 30% 30%, #122E5E 0%, #0A1F44 55%, #04102B 100%)",
                      boxShadow:
                        "0 18px 40px -22px rgba(212,175,55,0.55), inset 0 0 0 6px rgba(15,107,61,0.18)",
                    }}
                  >
                    <Icon size={32} strokeWidth={1.5} className="text-[#F0D788]" />
                  </div>
                  <div className="mt-5 font-display text-3xl text-[#D4AF37]">{num}</div>
                  <div className="mt-2 font-display text-xl tracking-wider text-white">
                    {title}
                  </div>
                  <p className="mt-2 text-white/65 text-sm max-w-[220px] leading-relaxed">
                    {desc}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
